import React from 'react';
import { Link } from 'react-router-dom';

export const Header = () => {
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="#" className="logo logo-dark">
                <span className="logo-sm"></span>
                <span className="logo-lg"></span>
              </Link>

              <Link to="#" className="logo logo-light">
                <span className="logo-sm"></span>
                <span className="logo-lg"></span>
              </Link>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};
